export interface Props extends workwave.Button {
  buttonPosition: ArrowButtonPosition
  size?: number
}

export enum ArrowButtonPosition {
  left,
  right,
}
